<template lang="pug">
    .checker(@click="toggle()")
        icon.small(v-if="checked",name="checked")
        icon.small(v-if="!checked", name="unchecked")
        div {{caption}}
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Icon from "@/components/Icon.vue";
export default {
    components: { Icon },
    props: ['checked', 'caption'],
    methods: {
        toggle() {
            console.log('switch ', this.caption, this.checked);
            const c = !this.checked
            this.$emit('update:checked', c);
        }
    }
}
</script>

<style lang="less" scoped>
.checker {
    display: flex;
    align-items: center;
    gap: 0.2rem;
    cursor: pointer;
}
</style>